import { useCallback, useEffect, useState } from "react";
import { foyerApi, type PremiseSummary } from "../http/foyer";

export function usePremisesList() {
  const [premises, setPremises] = useState<PremiseSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setPremises(await foyerApi.listPremises());
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { premises, loading, error, refresh };
}
